// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Controller } from 'swiper';

Swiper.use([Navigation, Pagination, Controller]);

export class SwiperClass {
  constructor()
  {

    /* eslint-disable */
    const swiper = new Swiper('.swiper-realisations', {
      spaceBetween: 0,
      slidesPerView: 1,
      loopedSlides: 50,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      loop: false,
      setWrapperSize: true,
      touchStartPreventDefault: false,
      observer: true,
      observeParents: true,

      breakpoints: {
        1800: {
          slidesPerView: 1,
        }
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="dot swiper-pagination-bullet me-4"></span>`;
        },
      },

    });
    /* eslint-enable */

    /* eslint-disable */
    const swiper_images = new Swiper('.swiper-images', {
      spaceBetween: 50,
      slidesPerView: 5,
      loopedSlides: 50,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      loop: false,
      setWrapperSize: true,
      touchStartPreventDefault: false,
      observer: true,
      observeParents: true,
      breakpoints: {
        1800: {
          slidesPerView: 5,
        },
        1500: {
          slidesPerView: 5,
        },
        1200: {
          slidesPerView: 4,
        },
        900: {
          slidesPerView: 3,
        },
        600: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 2,
        }
      },

    });
    /* eslint-enable */

  }
}



// WEBPACK FOOTER //
// ./js/util/swiper.js